(function() {
'use strict';

angular
    .module('dashboard')
    .factory('userSettingsService', userSettingsService);

function userSettingsService(resourceService) {
    const starRatings = [
       { name: resourceService.getDeferred('DASHBOARDRESOURCE_ANY'), val: 1 },
       { name: resourceService.getDeferred('DASHBOARDRESOURCE_2STARSANDHIGHER'), val: 2 },
       { name: resourceService.getDeferred('DASHBOARDRESOURCE_3STARSANDHIGHER'), val: 3 },
       { name: resourceService.getDeferred('DASHBOARDRESOURCE_4STARSANDHIGHER'), val: 4 },
       { name: resourceService.getDeferred('DASHBOARDRESOURCE_5STARS'), val: 5 }
    ];

    const smokingRoom = [
       { name: resourceService.getDeferred('NOPREFERENCE'), val: 0 },
       { name: resourceService.getDeferred('YES'), val: 1 },
       { name: resourceService.getDeferred('DASHBOARDRESOURCE_NO'), val: 2 }
    ];

    const boolianOptions = [
       { name: resourceService.getDeferred('YES'), val: true },
       { name: resourceService.getDeferred('DASHBOARDRESOURCE_NO'), val: false }
    ];

    const priceMode = [
       { name: resourceService.getDeferred('PERPERSON'), val: 0 },
       { name: resourceService.getDeferred('TOTALPRICE'), val: 1 }
    ];

    const flightClass = [
      { name: resourceService.getDeferred('DASHBOARDRESOURCE_ANY'), val: 0 },
      { name: resourceService.getDeferred('BUSINESSCLASS'), val: 8 },
      { name: resourceService.getDeferred('ECONOMYCLASS'), val: 1 },
      { name: resourceService.getDeferred('PREMIUMECONOMYCLASS'), val: 2 },
      { name: resourceService.getDeferred('FIRSTCLASS'), val: 4 }
    ];

    const hotelCriteria = [
      { name: resourceService.getDeferred('OURRECOMMENDATIONS'), val: 1 },
      { name: resourceService.getDeferred('CUSTOMERRATING'), val: 2 },
      { name: resourceService.getDeferred('PRICELOWTOHIGH'), val: 5 },
      { name: resourceService.getDeferred('PRICEHIGHTOLOW'), val: 6 },
      { name: resourceService.getDeferred('STARRATINGLOWTOHIGH'), val: 7 },
      { name: resourceService.getDeferred('STARRATINGHIGHTOLOW'), val: 8 }
    ];

    const flightCriteria = [
        { name: resourceService.getDeferred('OURRECOMMENDATIONS'), val: [10] },
        { name: resourceService.getDeferred('PRICELOWTOHIGH'), val: 1 },
        { name: resourceService.getDeferred('PRICEHIGHTOLOW'), val: 2 },
        { name: resourceService.getDeferred('DEPARTURETIMELOWTOHIGH'), val: 4 },
        { name: resourceService.getDeferred('DEPARTURETIMEHIGHTOLOW'), val: 5 },
        { name: resourceService.getDeferred('RETURNTIMELOWTOHIGH'), val: 6 },
        { name: resourceService.getDeferred('RETURNTIMEHIGHTOLOW'), val: 7 },
        { name: resourceService.getDeferred('TOTALJOURNEYTIMELOWTOHIGH'), val: 9 },
        { name: resourceService.getDeferred('TOTALJOURNEYTIMEHIGHTOLOW'), val: 8 }
    ];


    const adultTitles = resourceService.getDeferred('ADULTTITLES');

    const service = {
        getAdultTitles,
        getStarRatings,
        getSmokingRoomOptions,
        getPricMode,
        getFooterToolbarOptions,
        getFlightClassOptions,
        getHotelCriteria,
        getFlightCriteria,
        getCanceledBookingOprions
    };

    function getStarRatings() {
        return starRatings;
    }

    function getSmokingRoomOptions() {
        return smokingRoom;
    }

    function getFooterToolbarOptions() {
        return boolianOptions;
    }

    function getCanceledBookingOprions() {
        return boolianOptions;
    }

    function getPricMode() {
        return priceMode;
    }

    function getFlightClassOptions() {
        return flightClass;
    }

    function getAdultTitles() {
        return adultTitles;
    }


    function getHotelCriteria() {
        return hotelCriteria;
    }

    function getFlightCriteria() {
        return flightCriteria;
    }

    return service;
}
})();
